import { AnimatePresence, MotionStyle } from 'framer-motion';
import React, { useEffect } from 'react';
import { DrawerWrapper, Overlay } from './styles';

export type DrawerProps = {
    isOpen: boolean;
    children: React.ReactNode;
    stylesDrawer?: MotionStyle;
    toggleDrawer: () => void;
    drawerClassName?: string;
};

export const Drawer: React.FC<DrawerProps> = ({
    isOpen,
    children,
    stylesDrawer,
    toggleDrawer,
    drawerClassName,
}) => {
    useEffect(() => {
        //retirando o overflow externo quando tiver aberto
        if (isOpen) document.body.style.overflow = 'hidden';
        else document.body.style.overflow = 'auto';

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isOpen]);

    return (
        <AnimatePresence>
            {isOpen && (
                <Overlay onClick={toggleDrawer}>
                    <DrawerWrapper
                        className={drawerClassName}
                        style={stylesDrawer}
                        onClick={e => e.stopPropagation()}
                    >
                        {children}
                    </DrawerWrapper>
                </Overlay>
            )}
        </AnimatePresence>
    );
};
